export default [
  {
    name: 'Videos',
    path: 'videos',
    icon: 'video-camera-mono'
  }
];
